package dev.danko.roblox_craft_ai.uikit.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import dev.danko.roblox_craft_ai.uikit.i18n.strings
import dev.danko.roblox_craft_ai.uikit.icons.AppIcon
import dev.danko.roblox_craft_ai.uikit.icons.Icon
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import kotlinx.browser.localStorage
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

private const val TOUR_DONE_KEY = "robloxCraft.tourDone"

/** A three-step welcome shown once on the first visit: describe → get the result → send to Studio. */
@Composable
fun WelcomeTour() {
    val t = strings().tour
    val palette = LocalAppTheme.current.colors
    var visible by remember { mutableStateOf(runCatching { localStorage.getItem(TOUR_DONE_KEY) == null }.getOrDefault(false)) }
    var step by remember { mutableStateOf(0) }
    if (!visible) return

    fun finish() {
        runCatching { localStorage.setItem(TOUR_DONE_KEY, "1") }
        visible = false
    }

    val steps = listOf(
        Triple(AppIcon.SPARKLES, t.step1Title, t.step1Text),
        Triple(AppIcon.CODE, t.step2Title, t.step2Text),
        Triple(AppIcon.SEND, t.step3Title, t.step3Text)
    )
    val (icon, title, text) = steps[step]
    val last = step == steps.lastIndex

    ModalDialog(
        visible = true,
        onCloseRequest = { finish() },
        footer = {
            Row(Modifier.fillMaxWidth().gap(8.px), verticalAlignment = Alignment.CenterVertically) {
                AppButton(text = t.skip, variant = AppButtonVariant.GHOST, onClick = { finish() })
                Spacer()
                if (step > 0) AppButton(text = t.back, variant = AppButtonVariant.SECONDARY, onClick = { step-- })
                AppButton(text = if (last) t.start else t.next, onClick = { if (last) finish() else step++ })
            }
        }
    ) {
        Column(Modifier.fillMaxWidth().gap(14.px).padding(topBottom = 8.px), horizontalAlignment = Alignment.CenterHorizontally) {
            Box(
                Modifier.size(64.px).borderRadius(18.px).backgroundColor(palette.accent.toRgb().copy(alpha = 40)).color(palette.accentText),
                contentAlignment = Alignment.Center
            ) { Icon(icon, size = 30) }
            SpanText(t.stepOf(step + 1, steps.size), Modifier.fontSize(13.px).color(palette.textSecondary))
            SpanText(title, Modifier.fontSize(22.px).fontWeight(FontWeight.ExtraBold).color(palette.textPrimary).textAlign(com.varabyte.kobweb.compose.css.TextAlign.Center))
            SpanText(text, Modifier.fontSize(15.px).lineHeight(1.55).color(palette.textSecondary).textAlign(com.varabyte.kobweb.compose.css.TextAlign.Center).maxWidth(420.px))
            Row(Modifier.gap(6.px)) {
                steps.indices.forEach { i ->
                    Box(Modifier.width(if (i == step) 20.px else 8.px).height(8.px).borderRadius(999.px)
                        .backgroundColor(if (i == step) palette.accent else palette.borderStrong))
                }
            }
        }
    }
}
